import { FC, Fragment } from 'react'
import { Capitalized } from '@/components/atoms/typography'
import {
  ListPlainBox,
  ListColorBox,
  ListMotiveBox
} from '@/components/molecules/listItems'
import { ID } from 'graphql-ws'
import { FilterQueryItem } from '@/types/filterQueryItem'

type DropwDownItemGridItem = {
  id: ID
  title: string
  count: number
  color?: string
  isSelected: boolean
  englishName?: string
  onSelect: (id: ID) => void
}

export type DropwDownGridItemSection = {
  title?: string
  items: DropwDownItemGridItem[]
}

type DropDownItemGridProps = {
  sections: DropwDownGridItemSection[]
  highlight?: boolean
  typeDropDownItem?: string
}

const DropDownGridItem: FC<DropDownItemGridProps> = ({
  sections,
  highlight = true,
  typeDropDownItem
}) => {
  const formatedSections = sections.map(({ title, items }) => (
    <Fragment key={JSON.stringify(items)}>
      {title && (
        <Capitalized key={title} opacity={0.6}>
          {title}
        </Capitalized>
      )}
      {items.map(
        ({ id, title, count, onSelect, color, isSelected, englishName }) => {
          if (typeDropDownItem === FilterQueryItem.PATTERN) {
            return (
              <ListMotiveBox
                key={id || title}
                englishName={englishName}
                title={title}
                count={count}
                cursorOnHover={true}
                onClick={onSelect}
                isSelected={isSelected}
                highlight={highlight}
                data-cy="motive"
              />
            )
          } else if (typeDropDownItem === FilterQueryItem.COLOR) {
            return (
              <ListColorBox
                key={id || title}
                title={title}
                count={count}
                cursorOnHover={true}
                onClick={onSelect}
                isSelected={isSelected}
                color={color}
                highlight={highlight}
                data-cy="color"
              />
            )
          } else {
            return (
              <ListPlainBox
                key={id || title}
                title={title}
                count={count}
                cursorOnHover={true}
                isSelected={isSelected}
                onClick={onSelect}
                highlight={highlight}
                data-cy="plain"
              />
            )
          }
        }
      )}
    </Fragment>
  ))

  return <>{formatedSections}</>
}

export default DropDownGridItem
